import { Construction } from "lucide-react";
import { Link } from "react-router-dom";
import AppShell from "@/components/AppShell";

export default function ComingSoon({ title = "Coming soon", description }) {
  return (
    <AppShell requireAuth={false}>
      <div
        className="bg-white rounded-[18px] border border-[var(--cm-border)] p-14 text-center max-w-[760px] mx-auto"
        data-testid="coming-soon"
      >
        <div className="mx-auto w-16 h-16 rounded-[18px] bg-cm-lavender grid place-items-center mb-6">
          <Construction size={30} className="text-cm-blue" />
        </div>
        <h1 className="text-[30px] font-bold text-cm-navy tracking-tight">{title}</h1>
        <p className="mt-3 text-cm-grey text-[15px] leading-[1.8] max-w-[480px] mx-auto">
          {description ||
            "This section of the exchange is under active development. We're building it with the same care you've seen so far."}
        </p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link
            to="/dashboard"
            data-testid="cs-dashboard"
            className="inline-flex items-center px-6 py-3 rounded-[10px] bg-cm-blue text-white font-semibold text-[14px] hover:bg-cm-blue-deep transition"
          >
            Go to Dashboard
          </Link>
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 rounded-[10px] border border-[var(--cm-border)] text-cm-navy font-semibold text-[14px] hover:border-cm-blue hover:text-cm-blue transition"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </AppShell>
  );
}
